export default __webpack_public_path__ + "static/media/qr_code_final.3a8885ac.png";